<ion-app>
  <ion-split-pane when="lg" contentId="main">
    <ion-menu 
      menuId="mainMenu" 
      contentId="main" 
      side="start" 
      *ngIf="showMenu" 
      class="custom-menu">
      <app-nav-menu></app-nav-menu>
    </ion-menu>
    <div class="ion-page" id="main" [class.no-shell-header]="!(showMenu || errorMessage)">
      <ion-header [translucent]="true" *ngIf="showMenu || errorMessage">
        <app-topbar *ngIf="showMenu" [title]="'social-dash'"></app-topbar>
        <app-error-banner [errorMessage]="errorMessage" [errorCode]="errorCode" [logId]="errorLogId" (clearError)="clearErrorMessage()"></app-error-banner>
      </ion-header>
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>
